'use client';

import { SectionPageHeader } from '@web/ui';

import { JobHeaderContent } from './JobHeaderContent';

import type { JobStepId, JobSummaryDraft } from './new-job/types';
import type { SectionStepperTabItem } from '@web/ui';

export type JobPageHeaderStepItem = SectionStepperTabItem & {
  id: JobStepId;
};

type JobPageHeaderProps = {
  title: string;
  summary: JobSummaryDraft;
  activeStepId: JobStepId;
  steps: JobPageHeaderStepItem[];
  onStepChange: (stepId: JobStepId) => void;
};

export function JobPageHeader({
  title,
  summary,
  activeStepId,
  steps,
  onStepChange,
}: JobPageHeaderProps) {
  return (
    <SectionPageHeader
      title={title}
      showBackButton
      controlsTop={
        <JobHeaderContent
          summary={summary}
          activeStepId={activeStepId}
          steps={steps}
          onStepChange={onStepChange}
        />
      }
    />
  );
}
